import React from 'react';
import './SimpleMIUserCard.css';
import { format, parseISO } from 'date-fns';
import logComponent from '../../common/logComponent';
import MonitoredIndividualImage from '../MonitoredIndividualImage/MonitoredIndividualImage';

export default function SimpleMIUserCard({ miUser, border, nameOnly }) {
  const { monitoredIndividual } = miUser;
  const monitoredIndividualName = `${monitoredIndividual.legalFirstName} ${!!monitoredIndividual.preferredFirstName ? '(' + monitoredIndividual.preferredFirstName + ')' : ''} ${monitoredIndividual.lastName}`;

  if (logComponent('SimpleMIUserCard')) { console.debug('SimpleMIUserCard rendered'); }

  const getRoomNumbers = () => {
    if (logComponent('SimpleMIUserCard')) { console.debug('SimpleMIUserCard getRoomNumbers'); }

    let roomNumbers = [];
    if (miUser.monitoredIndividual.monitoredIndividualUnits) {
      roomNumbers = miUser.monitoredIndividual.monitoredIndividualUnits.filter(item => !item.EndOn).map(individualUnit => individualUnit.unit.name);
    }
    
    return roomNumbers;
  }
  const roomNumbers = getRoomNumbers();


  return (
    <div className={'Simple-MI-User-Card' + (border ? ' Simple-MI-User-Card--border' : '')}>
      <div className="Simple-MI-User-Card__image">
        <MonitoredIndividualImage monitoredIndividual={monitoredIndividual} />

      </div>
      <div>
        <p className="Simple-MI-User-Card__name">{monitoredIndividualName}</p>
        {
          !nameOnly &&
                  <React.Fragment>
                          {
                              monitoredIndividual.dateOfBirth != null &&
                              <span className="Simple-MI-User-Card__dob">{format(parseISO(monitoredIndividual.dateOfBirth), 'MMM d, yyyy')}</span>
                          }
            {
              roomNumbers.length > 0 &&
              <React.Fragment>
                <span className="Simple-MI-User-Card__dot">{' \u2022 '}</span>
                <span className="Simple-MI-User-Card__info">{roomNumbers.join(', ')}</span>
              </React.Fragment>
            }
          </React.Fragment>
        }
      </div>
    </div>
  );
}